import './App.css';
import Footer from './components/Foooter/Footer';
import Hero from './components/Herosection/Hero';
import Plans from './components/Plans/Plans';
import Programs from "./components/Programs/Programs";
import Reasons from "./components/Reasons/Reasons";
import Testimonials  from './components/Testimonials/Testimonials';
import Join from './components/Join/Join';

function App() {
  return (
    <div className="App">
      <Hero/>
      <Programs />
      <Reasons />
      <Plans />
      <Testimonials />
      <Join />
      <Footer />
    </div>
  );
}

export default App;
